import { endOfDay, isAfter } from 'date-fns'

export const getIsFutureDate = (date?: Date): boolean => {
  if (!date) return true

  return !isAfter(date, endOfDay(new Date()))
}
